import { CALL_API } from "../middleware/api";

export const FETCH_ORDER_ITEMS = "FETCH_ORDER_ITEMS";
export const SUCCESS_FETCH_ORDER_ITEMS = "SUCCESS_FETCH_ORDER_ITEMS";
export const FAILURE_FETCH_ORDER_ITEMS = "FAILURE_FETCH_ORDER_ITEMS";

export function fetchOrderItems({ orderId }) {
    return {
        type: FETCH_ORDER_ITEMS,
        [CALL_API]: {
            endpoint: `/api/orders/${orderId}/items`,
            method: 'get',
            types: [SUCCESS_FETCH_ORDER_ITEMS, FAILURE_FETCH_ORDER_ITEMS]
        },
        orderId: orderId
    }
}


// WEBPACK FOOTER //
// ./src/actions/orderItems.js